function hashStr(s) {
  let h = 2166136261;
  const str = String(s || "");
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function isMockResultsEnabled() {
  // CRA: env vars are baked at build time.
  const flag = String(process.env.REACT_APP_MOCK_RESULTS || "").trim();
  if (!flag) return false;
  if (process.env.NODE_ENV === "production") return false;
  return flag === "1" || flag.toLowerCase() === "true" || flag.toLowerCase() === "yes";
}

function clamp(n, lo, hi) {
  return Math.max(lo, Math.min(hi, n));
}

export function buildMockStandings(project) {
  const groups = project?.groups || {};
  const out = {};
  for (const g of Object.keys(groups)) {
    const codes = groups[g] || [];
    const rows = codes.map((code, idx) => {
      const seed = hashStr(`${project?.id}|${g}|${code}`);
      const pts = 3 * (3 - idx) + (seed % 4); // keep it plausible
      const gf = 3 + (seed % 7);
      const ga = clamp(gf - ((seed >> 3) % 4), 0, 99);
      const gd = gf - ga;
      const P = 3;
      const W = clamp(Math.floor(pts / 3), 0, 3);
      const D = clamp(pts - W * 3, 0, 3);
      const L = clamp(P - W - D, 0, 3);
      return { code, P, W, D, L, GF: gf, GA: ga, GD: gd, PTS: pts, rank: 0 };
    });
    rows.sort((a, b) => (b.PTS - a.PTS) || (b.GD - a.GD) || (b.GF - a.GF) || String(a.code).localeCompare(String(b.code)));
    rows.forEach((r, i) => (r.rank = i + 1));
    out[g] = rows;
  }
  return out;
}

export function buildMockLeaderboard(project) {
  const members = project?.member_users || [];
  const rows = members.map((u, i) => {
    const seed = hashStr(`${project?.id}|${u.id}|lb`);
    const matches_group = (seed % 30) + 10;
    const groups = ((seed >> 5) % 20) + 5;
    const matches_ko = ((seed >> 9) % 18);
    const finals = ((seed >> 13) % 20);
    const topscorer = ((seed >> 17) % 10);
    const matchTotal = matches_group + matches_ko;
    const accuracy_exact = Math.floor(matchTotal * 0.35);
    const accuracy_1x2 = matchTotal - accuracy_exact;
    const accuracy_group_place = groups;
    const accuracy_other = finals;
    const total = matches_group + groups + matches_ko + finals + topscorer;
    return {
      user_id: u.id,
      name: u.name,
      score: total,
      breakdown: {
        matches_group,
        groups,
        matches_ko,
        finals,
        topscorer,
        accuracy_1x2,
        accuracy_exact,
        accuracy_group_place,
        accuracy_topscorer: topscorer,
        accuracy_other,
      },
      rank: i + 1,
    };
  });
  rows.sort((a, b) => (b.score - a.score) || String(a.name || "").localeCompare(String(b.name || ""), "sv"));
  rows.forEach((r, i) => (r.rank = i + 1));
  return { rows, scorers: [], picks_by_player: {}, topscorer_picks_by_user: {} };
}

